import React, { ComponentType, FunctionComponent } from 'react';
import config from '../../config';

/**
 * Transform pdfs object into clickable button to download a pdf for each language
 *
 * @param Component
 */
function withMultipleLangFiles(
  Component: ComponentType<any>
): FunctionComponent {
  const Extension: FunctionComponent<Record<string, any>> = (props) => {
    const { record, source } = props;
    const isExpertInvoices = props.resource;
    const invoiceUploadedByUser = config.invoiceUploadedByUser;
    if (!record || !Array.isArray(record[source])) return null;
    const buttons = record[source].map((pdf: Record<string, any>) => ({
      id: pdf.id,
      href: pdf.public_url,
      label:
        invoiceUploadedByUser && record.uploaded_by_user && isExpertInvoices
          ? pdf.attachment_information?.language_alpha2 || ''
          : pdf.attachment_information?.language_alpha2 || '',
      icon: true,
    }));

    return <Component {...props} record={{ ...record, [source]: buttons }} />;
  };

  Extension.displayName = `withExtension(MultipleLangFiles)`;

  return Extension;
}

export default withMultipleLangFiles;
